import { Application } from 'api/application/types'
import { placements } from '../placement/data'
import { publishers } from '../publisher/data'

export const applications: Application[] = [
  {
    bundleId: 'com.top.score',
    id: '1',
    name: 'Cross Puzzle',
    notInStore: false,
    platform: 'android',
    publisher: publishers[0],
    status: 'enabled',
    clientSecurityToken: 'clientSecurityToken',
    sdkSecurityToken:
      'b26e853a4646d7139dcf058d3359f695e9ba32a2166dd11b3c0c187cc4f79112',
    rewardCallbackToken: 'rewardCallbackToken',
    rewardCallbackUrl: 'https://www.digitalturbine.com/callback',
    storeInfo: {},
    storeUrl: 'play.store/cross-puzzle',
    createdAt: '2021-12-07T22:55:13Z',
    updatedAt: '2022-01-28T18:02:39Z',
    placements: [placements[0], placements[1]],
    virtualCurrencies: [],
    apiFeedEnabled: true,
    apiFeedKey: '1234abcd',
    rankingSourceAppId: '2',
  },
  {
    bundleId: '1332535623143',
    id: '2',
    name: 'Kill Zombies',
    notInStore: false,
    platform: 'ios',
    publisher: publishers[0],
    status: 'enabled',
    clientSecurityToken: 'clientSecurityToken',
    sdkSecurityToken:
      'b26e853a4646d7139dcf058d3359f695e9ba32a2166dd11b3c0c187cc4f79099',
    rewardCallbackToken: 'rewardCallbackToken',
    rewardCallbackUrl: 'https://www.digitalturbine.com/callback',
    storeInfo: {},
    storeUrl: 'apple.store/kill-zombies',
    createdAt: '2021-12-07T22:55:13Z',
    updatedAt: '2022-01-28T18:02:39Z',
    placements: [placements[2], placements[3]],
    virtualCurrencies: [],
    rankingSourceAppId: '2222',
  },
]
